module.exports = "pegasus_template/assets/two-column-text-preview.png";